import React, { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { getGrantees } from "../core/service/grantees.service";

// material
import { Box, Grid, Container, Typography } from "@mui/material";
import { useSelector } from "react-redux";

// components
import Page from "../components/Page";
// import {
//   PostdocGranteeProgressChart,
//   ResearchPeriodExtensionChart,
//   PhDstudentGranteeProgressChart
// } from "../components/charts";
import { ProfileView } from "../components/profile";
import {
  StepperPostdoc,
  StepperPhd,
  UserTable,
  TableActivityProgressReport
} from "../components/_dashboard/app";
import Comment from "../components/profile/Comment";
// ----------------------------------------------------------------------

const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

const AnotherProfileMentor = (user, grantees = []) => {
  return (
    <Page title="MentorProfile">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Mentor Profile</Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={12}>
            <ProfileView anotherUser={user} />
          </Grid>

          {/* <Grid item xs={12} md={6} lg={8}>
            <PostdocGranteeProgressChart />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <PhDstudentGranteeProgressChart />
          </Grid> */}

          <Grid item xs={12} md={6} lg={12}>
            <UserTable
              ListUsers={grantees}
              currentUserRole={user?.role?.role}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

const AnotherProfileSTD = (user) => {
  return (
    <Page title="STDProfile">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">STD Profile</Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={12}>
            <ProfileView anotherUser={user} />
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <Typography sx={{ paddingBottom: 5 }} variant="h4">
              Research Progress
            </Typography>
            {user?.role?.role === ROLE_POSTDOC ? (
              <StepperPostdoc />
            ) : (
              <StepperPhd />
            )}
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <TableActivityProgressReport />
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <Comment user_id={user?.id} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default function AnotherProfile() {
  const navigate = useNavigate();
  const { user, isClickAnotherProfile } = useSelector(
    (state) => state.userProfileReducer
  );
  const [grantees, setGrantees] = useState([]);

  const getMentorGrantees = async (id) => {
    const data = await getGrantees(id);
    setGrantees(data.entities);
  };

  useEffect(() => {
    if (user?.role?.role === ROLE_MENTOR && isClickAnotherProfile)
      getMentorGrantees(user?.id);
  },[]);

  return (
    <>
      {user?.role?.role === ROLE_MENTOR
        ? AnotherProfileMentor(user, grantees)
        : AnotherProfileSTD(user)}
    </>
  );
}
